import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import VisitorsTable from "../../components/VisitorsTable";
import { logger } from "../../utils/logger";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TrafficPage = () => {
  const { fetchSessions } = useOutletContext();
  const [allVisitorsSessions, setAllVisitorsSessions] = useState([]);

  // Fetch all sessions (all visitors, not just currently active)
  const fetchAllVisitors = async () => {
    try {
      const accessToken = localStorage.getItem('access_token');
      if (!accessToken) return;

      const response = await axios.get(`${API}/sessions?filter_mode=visitors`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      setAllVisitorsSessions(response.data || []);
    } catch (error) {
      logger.error("Error fetching all visitors:", error);
    }
  };

  useEffect(() => {
    fetchAllVisitors();
  }, []);

  useEffect(() => {
    logger.log('[TrafficPage] Data received - sessions:', allVisitorsSessions?.length);
  }, [allVisitorsSessions]);

  return (
    <div className="h-full overflow-y-auto p-6">
      <VisitorsTable
        sessions={allVisitorsSessions}
        onRefresh={fetchAllVisitors}
      />
    </div>
  );
};

export default TrafficPage;
